import { render, staticRenderFns } from "./xianfenginfo.vue?vue&type=template&id=6996c1e9&scoped=true"
import script from "./xianfenginfo.vue?vue&type=script&lang=js"
export * from "./xianfenginfo.vue?vue&type=script&lang=js"
import style0 from "./xianfenginfo.vue?vue&type=style&index=0&id=6996c1e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6996c1e9",
  null
  
)

export default component.exports